import { useDispatch } from 'react-redux';
import { Box } from "@mui/system";
import { useState } from "react";
import { useSelector } from "react-redux";
import FilterComponent from '../../../../ReusableFIlterComponent/FilterComponent';
import { setCreatedOnDate, setSelectedAssignee, setSelectedCategory, setSelectedDueDate, setSelectedStatus, setSelectedSubCategory, } from '../../../../../features/businessInsightsSlice';
interface Props {
  clearSelectedBusinessInsights: any;
}

const InsightsFiltersCard = ({ clearSelectedBusinessInsights }: Props) => {
  const filteredInsights = useSelector((state: any) => state.businessInsights?.filteredInsights);
  const categoriesToKeep = ['User Acquisition', 'Player Value']; // Define the categories to keep
  const requiredInsights = filteredInsights?.filter((task: any) => {
    const categody = task?.data && task?.data['query_output:category'] && task?.data['query_output:category'].value;
    return categoriesToKeep.includes(categody);
  });
  const selectedCategory = useSelector((state: any) => state.businessInsights?.selectedCategory);
  const selectedSubCategory = useSelector((state: any) => state.businessInsights?.selectedSubCategory);
  const selectedStatus = useSelector((state: any) => state.businessInsights?.selectedStatus);
  const createdOnDate = useSelector((state: any) => state.businessInsights?.createdOnDate);
  const selectedDueDate = useSelector((state: any) => state.businessInsights?.selectedDueDate);
  const selectedAssignee = useSelector((state: any) => state.businessInsights?.selectedAssignee);
  const [searchStatus, setSearchStatus] = useState("");
  const [searchAssignee, setSearchAssignee] = useState("");
  const dispatch = useDispatch();
  const categoryNames = requiredInsights.map((item: any) => {
    const categoryName = item.data?.["query_output:category"]?.value;
    return categoryName ? { "query_output:category": categoryName } : null; // Return null if undefined
  }).filter((item: any) => item !== null);

  const subcategoryNames = requiredInsights.map((item: any) => {
    const categoryName = item.data?.["query_output:subcategory"]?.value;
    return categoryName ? { "query_output:subcategory": categoryName } : null; // Return null if undefined
  }).filter((item: any) => item !== null);
  const [searchCategory, setSearchCategory] = useState("");
  const [searchSubCategory, setSearchSubCategory] = useState("");
  const filterConfig = [
    {
      key: "category",
      label: "Category",
      searchTerm: searchCategory,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => setSearchCategory(e.target.value),
      selectedOption: selectedCategory,
      filterName: "query_output:category",
      data: categoryNames,
      onSelectionChange: (updatedSelection: any) => dispatch(setSelectedCategory(updatedSelection)),
      count: selectedCategory && selectedCategory.length,
      colorSelected: selectedCategory !== null && selectedCategory.length > 0 ? "#9C27B0" : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "Insight Type",
      label: "Insight Type",
      searchTerm: searchSubCategory,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => setSearchSubCategory(e.target.value),
      selectedOption: selectedSubCategory,
      filterName: "query_output:subcategory",
      data: subcategoryNames,
      onSelectionChange: (updatedSelection: any) => dispatch(setSelectedSubCategory(updatedSelection)),
      count: selectedSubCategory && selectedSubCategory.length,
      colorSelected: selectedSubCategory !== null && selectedSubCategory.length > 0 ? "#9C27B0" : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "status",
      label: "Select Status",
      searchTerm: searchStatus,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => setSearchStatus(e.target.value),
      selectedOption: selectedStatus,
      filterName: "current_status",
      data: requiredInsights,
      onSelectionChange: (updatedSelection: any) => dispatch(setSelectedStatus(updatedSelection)),
      count: selectedStatus && selectedStatus.length,
      colorSelected: selectedStatus !== null && selectedStatus.length > 0 ? "#9C27B0" : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "Due Date",
      label: "Select Date",
      searchTerm: "",
      selectedOption: selectedDueDate,
      filterName: "due_date",
      data: requiredInsights,
      onSelectionChange: (updatedSelection: any) => dispatch(setSelectedDueDate(updatedSelection)),
      count: selectedDueDate && selectedDueDate.length - 1,
      colorSelected: selectedDueDate !== null && selectedDueDate.length > 0 ? "#9C27B0" : "#000000DE",
      multiSelect: true,
      showSearch: false,
      isDateRangeFilter: true,
    },
    {
      key: "assignee",
      label: "Select Assignee",
      searchTerm: searchAssignee,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => setSearchAssignee(e.target.value),
      selectedOption: selectedAssignee,
      filterName: "assignee_fullname",
      data: requiredInsights,
      onSelectionChange: (updatedSelection: any) => dispatch(setSelectedAssignee(updatedSelection)),
      count: selectedAssignee && selectedAssignee.length,
      colorSelected: selectedAssignee !== null && selectedAssignee.length > 0 ? "#9C27B0" : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "created on",
      label: "Select Date",
      searchTerm: "",
      selectedOption: createdOnDate,
      filterName: "created_at",
      data: requiredInsights,
      onSelectionChange: (updatedSelection: any) => dispatch(setCreatedOnDate(updatedSelection)),
      count: createdOnDate && createdOnDate.length - 1,
      colorSelected: createdOnDate !== null && createdOnDate.length > 0 ? "#9C27B0" : "#000000DE",
      multiSelect: true,
      showSearch: false,
      isDateRangeFilter: true,
    },
  ];

  //-- Remove filters
  const clearFilters = () => {
    clearSelectedBusinessInsights(null);
    dispatch(setSelectedCategory(null));
    dispatch(setSelectedSubCategory(null));
    dispatch(setSelectedStatus(null));
    dispatch(setCreatedOnDate(null));
    dispatch(setSelectedAssignee(null));
    dispatch(setSelectedDueDate(null));
    setSearchCategory("");
    setSearchSubCategory("");
    setSearchStatus("");
    setSearchAssignee("");
  };

  return (
    <>
      <Box>
        <FilterComponent filterConfig={filterConfig} clearFilters={clearFilters} />
      </Box>
    </>
  )
}

export default InsightsFiltersCard
